import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, CurrencyField, Button} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const [newHourlyRate, setnewHourlyRate] = React.useState('');
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(false);

  const caregiverPaymentPlan = props.caregiverPaymentPlan;
  const updateCaregiverHourlyRate = props.updateCaregiverHourlyRate;
  const setViewMode = props.setViewMode;

  React.useEffect(() => {
    if (caregiverPaymentPlan && caregiverPaymentPlan.hourlyRate != null) {
      setnewHourlyRate(caregiverPaymentPlan.hourlyRate);
    } else {
      setnewHourlyRate('');
    }
  }, [caregiverPaymentPlan]);


  React.useEffect(() => {
    setIsSaveDisabled(!newHourlyRate);
  }, [newHourlyRate]);

  const onSave = () => {
    setIsSaving(true);
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateCaregiverHourlyRate(newHourlyRate, onSuccess);
  };

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        'display': 'flex',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression='caregiver.CaregiverDetail.Payment.PaymentPlan.HourlyRateTitle'
          />
        </Typography>
      </Box>
      <Box>
        <CurrencyField
          value={newHourlyRate}
          onChange={setnewHourlyRate}
          style = {{
            width: '100%',
            maxWidth: 100,
            width: 'fit-content',
          }}
        />
      </Box>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          <Translate expression='generic.Save' />
        </Button>
      </Stack>
    </Stack>
  );
};

Content.propTypes = {
  caregiverPaymentPlan: PropTypes.object.isRequired,
  updateCaregiverHourlyRate: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
